module.exports = __webpack_public_path__ + "img/sony.0ee424b9.png";